import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, Radio, Text } from '@dixa/lib-shared-habla';
import styles from './elevioRadioItem.module.scss';
/**
 * Radio control item used to configure elevio integration. When active shows
 * additional configuration options.
 */
export function ElevioRadioItem({ isActive, label, description, children, onRadioChange, }) {
    const id = label.replace(/\s/g, '-').toLowerCase();
    return (_jsxs("div", { children: [_jsxs(FlexBox, Object.assign({ gap: "100", alignItems: "center" }, { children: [_jsx(Radio, { checked: isActive, id: id, onChange: onRadioChange }), _jsx("label", Object.assign({ htmlFor: id, className: styles.radioLabel }, { children: label }))] })), _jsxs(Box, Object.assign({ margin: "100 0 0 500" }, { children: [_jsx(Text.Paragraph, { children: description }), isActive && children] }))] }));
}
